import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CommonNav from "../../main/CommonNav";
import Footer from "../../main/Footer";

import BuddibleSocket from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import i18n from "i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function WritePost() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [pwDisabled, setPwDisabled] = useState(true);
  const [qaData, setQaData] = useState({
    qaUSERName: "",
    qaTITLE: "",
    qaCONTENTS: "",
    qaTYPE: "",
    qaPublicYN: "Y",
    qaPWD: "",
    qaIDX: "",
    qaINSERTDATE: new Date(),
    qaUSEYN: "Y",
    qaUSERID: "",
    qaCompCD: "",
  });

  const controller = {
    qaTITLE: useRef(),
    qaCONTENTS: useRef(),
    qaUSERName: useRef(),
    qaPWD: useRef(),
    qaTYPE: useRef(),
    qaPublicYN: useRef(),
  };

  let loginInfo = null;
  if (sessionStorage.getItem("loginInfo")) {
    loginInfo = JSON.parse(
      util.buddibleDecrypt(sessionStorage.getItem("loginInfo"))
    );
  }

  useEffect(() => {
    i18n.changeLanguage(i18n.language);
    if (loginInfo !== null) {
      controller.qaUSERName.current.value = loginInfo["returnData"][0].user_nm;
    }
  }, []);

  function changePublicYN(e) {
    let val = e.target.value;
    let setData = {};
    if (val === "N") {
      if (loginInfo !== null) {
        controller.qaPWD.current.value = loginInfo["returnData"][0].comp_cd;
        setData.qaPWD = loginInfo["returnData"][0].comp_cd;
        setPwDisabled(true);
      } else {
        setPwDisabled(false);
      }
    } else {
      controller.qaPWD.current.value = "";
    }
    setQaData({ ...qaData, ...setData, qaPublicYN: val });
  }

  function checkValidation() {
    if (controller.qaTITLE.current.value.trim() === "") {
      codeList.Modal.current.alert(t("post.write.msg.validation.title"));
      return false;
    }
    if (controller.qaTYPE.current.value.trim() === "") {
      codeList.Modal.current.alert(t("post.write.msg.validation.type"));
      return false;
    }
    if (controller.qaUSERName.current.value.trim() === "") {
      codeList.Modal.current.alert(t("post.write.msg.validation.name"));
      return false;
    }
    if (controller.qaCONTENTS.current.value.trim() === "") {
      codeList.Modal.current.alert(t("post.write.msg.validation.contents"));
      return false;
    }
    if (qaData.qaPublicYN === "N") {
      if (controller.qaPWD.current.value.trim() === "") {
        codeList.Modal.current.alert(t("post.write.msg.validation.password"));
        return false;
      }
    }
    return true;
  }

  function INSERT_QNA_DATA(updateData) {
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/qa/JS_qa_insert.php",
      msgID: msgID,
      data: {},
      ...updateData,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData && newData.ret) {
        codeList.Modal.current.alert(t("post.write.msg.successSave"), () => {
          navigate("/PostList/qna");
        });
      }
    });
  }

  function actionSave() {
    if (checkValidation()) {
      codeList.Modal.current.confirm(t("post.write.msg.confirmSave"), (ret) => {
        if (ret) {
          let updateData = {
            qaUSERName: controller.qaUSERName.current.value,
            qaTITLE: controller.qaTITLE.current.value,
            qaCONTENTS: controller.qaCONTENTS.current.value,
            qaTYPE: controller.qaTYPE.current.value,
            qaPublicYN: qaData.qaPublicYN,
            qaPWD: controller.qaPWD.current.value,
            qaIDX: "",
            qaINSERTDATE: new Date(),
            qaUSEYN: "Y",
            qaUSERID: loginInfo ? loginInfo["returnData"][0].user_id : "",
            qaCompCD: loginInfo ? loginInfo["returnData"][0].comp_cd : "",
          };
          INSERT_QNA_DATA(updateData);
        } else {
          codeList.Modal.current.alert(t("post.write.msg.cancelSave"));
        }
      });
    }
  }

  return (
    <>
      <CommonNav />
      <main style={{ marginTop: 56, minHeight: "100vh" }} className="bg-white">
        <div className="container py-4">
          <div className="row">
            <div className="col-12 mb-2">
              <p className="h5 font-weight-bold">{t("post.write.title")}</p>
            </div>
            <div className="col-12 d-flex flex-row mb-3">
              <input
                className="form-control mr-3"
                type="text"
                placeholder={t("post.write.placeholder.title")}
                ref={controller.qaTITLE}
              />
              <select className="form-control w-25" ref={controller.qaTYPE}>
                <option value="">{t("post.write.select.type")}</option>
                <option value="FJA0">
                  {t("post.write.select.options.FJA0")}
                </option>
                <option value="FJA1">
                  {t("post.write.select.options.FJA1")}
                </option>
                <option value="FJA2">
                  {t("post.write.select.options.FJA2")}
                </option>
                <option value="FJA3">
                  {t("post.write.select.options.FJA3")}
                </option>
                <option value="FJA4">
                  {t("post.write.select.options.FJA4")}
                </option>
              </select>
            </div>
            <div className="col-12 d-flex flex-row mb-3">
              <input
                className="form-control mr-3"
                type="text"
                placeholder={t("post.write.placeholder.name")}
                ref={controller.qaUSERName}
              />
              <input
                className="form-control mr-3"
                type="password"
                placeholder={t("post.write.placeholder.password")}
                ref={controller.qaPWD}
                disabled={pwDisabled}
              />
              <div className="btn-group btn-group-toggle">
                <label
                  className={`btn btn-light ${
                    qaData.qaPublicYN === "N" ? "active" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="public"
                    value="N"
                    onClick={(e) => changePublicYN(e)}
                  />
                  <i className="icon-lock" />
                </label>{" "}
                <label
                  className={`btn btn-light ${
                    qaData.qaPublicYN === "Y" ? "active" : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="public"
                    value="Y"
                    onClick={(e) => changePublicYN(e)}
                  />
                  <i className="icon-lock-open-alt" />
                </label>
              </div>
            </div>
            <div className="col-12">
              <textarea
                className="form-control"
                rows={20}
                placeholder={t("post.write.placeholder.contents")}
                ref={controller.qaCONTENTS}
              />
            </div>
            <div className="col-12 py-3 d-flex flex-row justify-content-center">
              <Link
                to="/PostList/qna"
                className="btn btn-outline-secondary rounded-sm px-5 mr-1"
              >
                {t("post.write.buttons.list")}
              </Link>
              <div
                className="btn btn-info px-5 rounded-sm ml-1"
                onClick={() => actionSave()}
              >
                {t("post.write.buttons.submit")}
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
